import { createIcon, Svg } from "@gluestack-ui/icon";
import { Path } from "react-native-svg";

const CheckHeartIcon = createIcon({
  Root: Svg,
  viewBox: "0 0 20 20",
  path: (
    <>
      <Path
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="m7.5 9.167 1.666 1.666 3.75-3.75M9.994 4.28C8.328 2.332 5.55 1.808 3.462 3.592c-2.087 1.783-2.381 4.765-.742 6.875 1.238 1.593 4.756 4.792 6.403 6.262.303.27.454.405.632.459a.845.845 0 0 0 .479 0c.177-.054.328-.189.631-.459 1.647-1.47 5.165-4.669 6.403-6.262 1.64-2.11 1.382-5.11-.742-6.875-2.123-1.765-4.866-1.26-6.532.688Z"
      />
    </>
  ),
});

CheckHeartIcon.displayName = "CheckHeartIcon";
export { CheckHeartIcon };
